/**
 * Горизонтальный свайп «назад» на полноэкранных мобильных модалках и сайдбаре.
 * По умолчанию выключен: при вертикальном скролле жест часто срабатывает случайно.
 */
export const ENABLE_MODAL_SWIPE_BACK = false;
